import event from '@/api/event'
import branch from '@/api/branch'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return event.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return event.store(data)
  },

  async find(context, id) {
    return await event.find(id)
  },

  update(context, data) {
    return event.update(data)
  },

  delete(context, data) {
    return event.destroy(data)
  },
  getBranch(context, attributes = {}) {
    return branch.get({
      params: {
        fields: {
          setup_branch_profiles: 'branch_id,branch_name_en'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  }
}
